var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4326_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.300049C5.37704 0.300049 0 5.54595 0 12.0074C0 18.4688 5.37704 23.7147 12 23.7147C18.6229 23.7147 24 18.4688 24 12.0074C24.0164 5.54595 18.6393 0.300049 12 0.300049ZM17.2787 13.4948H13.8852V14.7423C13.8852 17.2533 11.8033 19.2845 9.22949 19.2845C6.65573 19.2845 4.57376 17.2533 4.57376 14.7423C4.57376 12.2313 6.65573 10.2001 9.22949 10.2001H10.4918V13.5108H13.8852V10.1841H17.2787V13.4948ZM18.9672 8.52076H15.1475C14.4426 8.52076 13.8852 9.08054 13.8688 9.76826V10.1841H10.4918V9.76826C10.4918 7.25727 12.5738 5.22608 15.1475 5.22608H18.9672V8.52076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2131 13.4948C8.50818 13.4948 7.93441 14.0545 7.93441 14.7423C7.93441 15.43 8.50818 15.9898 9.2131 15.9898C9.91802 15.9898 10.4918 15.43 10.4918 14.7423V13.4948H9.2131C9.2131 13.4788 9.2131 13.4788 9.2131 13.4948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4918 13.4788H13.8852L13.8852 10.1841H10.4918V13.4788Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4326_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.263ed6b940e097fb92a4b5053763328e.svg";
export { ForwardRef as ReactComponent };